import { WithCopyButton } from "./withCopyButton";

export const TextInputCompositions = {
    WithCopyButton,
};

export type { WithCopyButtonProps as TextInputWithCopyButtonProps } from "./withCopyButton";
